window.addEventListener('scroll', function() {
  if (window.scrollY > 50) {
    document.querySelector('sticky-header').classList.add('scrolling');
  } else {
    document.querySelector('sticky-header').classList.remove('scrolling');
  }
});


const body = document.querySelector('body');
if(body.classList.contains('template-collection')){
  document.addEventListener("DOMContentLoaded", function() {
      document.querySelector(".first-grid-changer").addEventListener("click", function() {
        this.classList.add("active");
        document.querySelector(".second-grid-changer").classList.remove("active");
        var elements = document.querySelectorAll("#product-grid.product-grid");
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.add("grid--1-col-tablet-down");
          elements[i].classList.remove("grid--2-col-tablet-down");
        }
      });

      // Function to remove class .small--one-full when clicking on .second-grid-changer
      document.querySelector(".second-grid-changer").addEventListener("click", function() {
         this.classList.add("active");
        document.querySelector(".first-grid-changer").classList.remove("active");
        var elements = document.querySelectorAll("#product-grid.product-grid");
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.remove("grid--1-col-tablet-down");
          elements[i].classList.add("grid--2-col-tablet-down");
        }
      });
    });
}


if(body.classList.contains == 'template-product'){
  const headings = document.querySelectorAll('.tabs-heading');
        // Get all the p elements with class "tabs-content"
        const contents = document.querySelectorAll('.tabs-content');

        // Add click event listeners to each h1 element
        headings.forEach((heading) => {
            heading.addEventListener('click', () => {
                // Remove the "active" class from all p elements
                contents.forEach((content) => {
                    content.classList.remove('active');
                });

                // Get the ID of the clicked h1 element
                const targetId = heading.getAttribute('id');

                // Find the corresponding p element with the same ID and add the "active" class
                const targetContent = document.getElementById(targetId);
                targetContent.classList.add('active');
            });
        });
}

document.addEventListener("DOMContentLoaded", function () {
    var typeRadioInputs = document.querySelectorAll('input[type="radio"][name="Type"]');
    var sizeRadioInputs = document.querySelectorAll('input[type="radio"][name="Size"]');
    var sizeFieldset = sizeRadioInputs.length ? sizeRadioInputs[0].closest('fieldset') : null;

    function updateSizeFieldset() {
        var selectedValue = document.querySelector('input[type="radio"][name="Type"]:checked').value;

        if (selectedValue === "Stitched") {
            if (sizeFieldset) sizeFieldset.style.display = "block";
            sizeRadioInputs[1].click();
        } else if (selectedValue === "Unstitched") {
            if (sizeFieldset) sizeFieldset.style.display = "none";
            sizeRadioInputs[0].click();
        }
    }

    if (typeRadioInputs.length && sizeFieldset) {
        sizeFieldset.style.display = "none"; // Initially hide if Type options exist

        typeRadioInputs.forEach(function (radio) {
            radio.addEventListener("change", updateSizeFieldset);
        });

        // Trigger once on load in case default is already selected
        updateSizeFieldset();
    }
});


